import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin"
gsap.registerPlugin(ScrollToPlugin);

export const getDisplayMode = () =>{
  var layoutMode = null;
  var LAYOUTMODE__DESKTOP = 1;
  var LAYOUTMODE__MODILE = 2;
  var BREAK_POINT = "(min-width: 769px)";

  function matchMedia() {
    if (window.matchMedia(BREAK_POINT).matches) {
      if (layoutMode == LAYOUTMODE__DESKTOP) return;
      layoutMode = LAYOUTMODE__DESKTOP;

    } else {
      if (layoutMode == LAYOUTMODE__MODILE) return;
      layoutMode = LAYOUTMODE__MODILE;
    }

    return layoutMode;
  }

  function resize() {
    return matchMedia();
  }

  window.addEventListener('resize', function() {
    return resize()
  });

  return resize();

};

export const spanWrapText = (targets) => {
  targets.forEach( function (target) {
    let nodes = [...target.childNodes];
    let textBox = '';
    nodes.forEach( function (node) {
      if (node.nodeType == 3) { //テキストの場合
        let text = node.textContent.replace(/\r?\n/g, ''); //テキストから改行コード削除
        text.split('').forEach(function (t) {
          if (t !== " ") {
          textBox += '<span class="char">' + t + '</span>';
        } else {
          textBox += t;
        }
      });
    } else if (node.contains(node) == true) { // テキストではなく、子ノード(=span要素)を持つ
      let childNodes = [...node.childNodes];
      let childTextBox = '';
      childNodes.forEach( function (childeNode) {
        if (childeNode.nodeType == 3) { //テキストの場合
          let childeText = childeNode.textContent.replace(/\r?\n/g, ''); //テキストから改行コード削除
          childeText.split('').forEach(function (ct) {
            if (ct !== " ") {
              childTextBox += '<span class="char">' + ct + '</span>';
            } else {
              childTextBox += ct;
            }
          });
        } else if (childeNode.contains(node) == true) {
            // そのまま連結
            childTextBox = childTextBox + childeNode.outerHTML;
        } else {
            childTextBox = childTextBox + childeNode.outerHTML;
        }
      })

      node.innerHTML = childTextBox
      textBox = textBox + node.outerHTML;

    } else { // テキストではなく、br要素などspan要素以外の要素を持つ
        textBox = textBox + node.outerHTML;
      }
    })
    target.innerHTML = textBox
  })

  return targets;
};

export const smoothScroll = () => {
  console.log('test')
  const headerHeight = document.querySelector('#site-header').clientHeight;

  function setSmoothScroll() {
    const smoothScrollTrigger = document.querySelectorAll('.anc-nav');

    for (let i = 0; i < smoothScrollTrigger.length; i++){
      smoothScrollTrigger[i].addEventListener('click', (e) => {
        e.preventDefault();
        let href = smoothScrollTrigger[i].getAttribute('href');
        gsap.to(window, {
          ease: "power2.Out",
          duration: .5,
          scrollTo: {
            y: href,
            // offsetY: headerHeight
          }
        });
      });
    }
  }

  setSmoothScroll();
};

export const setPageTop = () => {
  function setPageTop() {
    const pageTop = document.querySelector('.js-pagetop')

    pageTop.addEventListener('click', () => {
      gsap.to(window, {
        ease: "power2.Out",
        duration: .5,
        scrollTo: {
          y: 0,
        }
      });
    })
  }

  setPageTop();
};